import { addDays, format, isSameDay, parse } from 'date-fns/esm'

export type TimeWindowException = {
  date: Date
  list: uui.domain.rm.TimeWindow[]
}

const todayClient = new Date()

export const DEFAULT_NEW_VALUE: uui.domain.rm.TimeWindow = {
  startSec: 9 * 60 * 60,
  endSec: 18 * 60 * 60,
}

const isDateInList = (date: Date, list: TimeWindowException[]): boolean => {
  const foundIndex = list.findIndex((item: TimeWindowException) => {
    const { date: dateItem } = item
    return isSameDay(date, dateItem)
  })
  return foundIndex !== -1
}

const getFirstDayAvailable = (start: Date, list: TimeWindowException[]): Date => {
  if (!isDateInList(start, list)) return start
  let loopDate = start
  do {
    loopDate = addDays(loopDate, 1)
  } while (isDateInList(loopDate, list))
  return loopDate
}

export const formatField = (
  exceptions?: Record<string, uui.domain.rm.TimeWindow[]>,
): TimeWindowException[] => {
  const values = !!exceptions ? Object.entries(exceptions) : []
  return values.map(([dateAsString, list]) => {
    const date: Date = parse(dateAsString, 'yyyyMMdd', todayClient)
    return {
      date,
      list,
    }
  })
}

export const parseField = (
  field: TimeWindowException[],
): Record<string, uui.domain.rm.TimeWindow[]> => {
  return field.reduce((acc: uui.domain.rm.TimeWindowExceptions, tw: TimeWindowException) => {
    const { date, list } = tw
    const dateAsString: string = format(date, 'yyyyMMdd')
    acc[dateAsString] = list
    return acc
  }, {})
}

export const getDefaultValue = (
  value: Record<string, uui.domain.rm.TimeWindow[]>,
): TimeWindowException => {
  const formattedData = formatField(value)
  const date = getFirstDayAvailable(todayClient, formattedData)
  return {
    date,
    list: [DEFAULT_NEW_VALUE],
  }
}
